import React from 'react'
import { CategoryCard, CategoryOverlay, CategoryText, CategoryTag } from './styles'
import { Lk } from '../../../Links/Lk'
import { logEvent } from '../../../../Utils'
import { ANALYTICS_TAGS } from '../../../../Constant'
import { FeedCategoryItem } from 'Api/Feed/feed.types'

type CategoryViewProps = {
  category: FeedCategoryItem
}

export const CategoryView: React.FC<React.PropsWithChildren<CategoryViewProps>> = ({
  category,
}) => {
  const handleCategoryClick = async () => {
    try {
      const analyticsParams = {
        category_name: category.title,
        category_tag: category.tags,
        location: 'video_categories',
      }

      logEvent(ANALYTICS_TAGS.video_category_click, analyticsParams)
    } catch (error) {
      console.error('Analytics error in CategoryView:', error)
    }
  }

  const shouldShowTag = (): boolean => {
    if (!category?.indicators || category.indicators.length === 0) {
      return false
    }
    return true
  }

  const getTagText = (): string => {
    return category.indicators.length > 0 ? category.indicators[0] : ''
  }

  if (!category.previewImage || !category.title || !category.tags) {
    console.error('CategoryView: Missing required category data', category)
    return null
  }

  const categoryUrl = `/videos/tag/${category.tags}`

  return (
    <Lk
      link={categoryUrl}
      alt={`View ${category.title} videos`}
      onBeforeNavigate={handleCategoryClick}
    >
      <CategoryCard backgroundImage={category.previewImage}>
        {shouldShowTag() && <CategoryTag>{getTagText()}</CategoryTag>}
        <CategoryOverlay>
          <CategoryText>{category.title}</CategoryText>
        </CategoryOverlay>
      </CategoryCard>
    </Lk>
  )
}
